let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bjmre")).then(() => parcelRequire('9R9u0'));